import React from "react";
import { compose } from "redux";
import { Redirect } from "react-router";
import { withRouter } from "react-router-dom";
import withTranslations from "../../../../../hocs/withTranslations";
import withResetPasswordModal from "../../../../../hocs/withResetPasswordModal";
import withUserData from "../../../../../hocs/withUserData";
import FormBuilderWeb from "../../../../../lib/FormBuilder/FormBuilderWeb";
import Formsy from "formsy-react";
import SquaberLink from "../../../common/SquaberLink";
import AuthPageLayout from "../../../auth/AuthPageLayout";
import { getPasswordLoginHref } from "../../../../../lib/auth/authLoginPageTypes";
import "../../../auth/authForm.scss";

function ForgotPasswordPage({
  formBuilder,
  trigger,
  userData,
  locale,
  translate,
  history
}) {
  if (userData) {
    return <Redirect to={"/"} />;
  }

  const loginTo = getPasswordLoginHref(locale);

  return (
    <AuthPageLayout
      title={translate("auth_forgot-password-page_title")}
      subtitle={translate("auth_forgot-password-page_subtitle")}
    >
      <Formsy
        onValidSubmit={() => {
          trigger({
            fields: formBuilder.fields,
            callback: () => {
              history.push(loginTo);
            }
          });
        }}
      >
        <FormBuilderWeb {...formBuilder} />
        <button
          type={"submit"}
          className={
            "hover.button focus.button disabled.button bg-yellow text-black text-lg py-4.5 border-none rounded-1xl px-7 font-semibold line-height-100 w-full mt-8 mb-6"
          }
        >
          {translate("auth_forgot-password-page_submit")}
        </button>
        <p className={"text-sm line-height-100 font-medium text-black-5 mb-8"}>
          {translate("auth_forgot-password-page_remember-password")}{" "}
          <strong className={"font-bold text-black"}>
            <SquaberLink to={loginTo} className={"ml-2"}>
              {translate("auth_forgot-password-page_login-link")}
            </SquaberLink>
          </strong>
        </p>
      </Formsy>
    </AuthPageLayout>
  );
}

export default compose(
  withTranslations,
  withResetPasswordModal,
  withUserData,
  withRouter
)(ForgotPasswordPage);
